<template>
  <vx-card class="mt-base">
    <div>
      <heading size="h2" style-size="h4" class="mb-2">Reflection</heading>
      <p class="my-5" v-if="loginType == 'student'">
        Your reflection on this job experience is shown below (if it is blank then you did not
        complete it).
      </p>
      <p class="my-5" v-else>
        This student's reflection on this job experience is shown below (if it is blank then they
        did not complete it).
      </p>
      <template v-if="postwork != null">
        <form id="form">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span role="heading" aria-level="3">Name of Job/Career experienced:</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ postwork.reflection.job_name }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span role="heading" aria-level="3"
                >What enterprise skills do you feel you developed?</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="vx-row mb-6 ml-1">
                <li
                  class="vx-col sm:w-1/3 w-full my-1 skillWrapper"
                  v-for="skill in skills"
                  :key="skill"
                >
                  <feather-icon
                    class="sm:inline-flex hasSkill"
                    icon="CheckIcon"
                    v-if="
                      typeof postwork.reflection.skills !== 'undefined' &&
                      postwork.reflection.skills.includes(skill)
                    "
                  />
                  {{ skill }}
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span role="heading" aria-level="3"
                >What are 3 things you learned about this job?</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div v-for="(i, index) in 3" :key="index" class="mb-5">
                {{ i }}. {{ postwork.reflection['learned' + i] }}
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span role="heading" aria-level="3"
                >Can you see yourself doing this job in the future?</span
              >
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span
                v-if="
                  postwork.reflection.do_job_in_future === true ||
                  postwork.reflection.do_job_in_future === 1
                "
                >Yes</span
              >
              <span
                v-if="
                  postwork.reflection.do_job_in_future === false ||
                  postwork.reflection.do_job_in_future === 0
                "
                >No</span
              >
              <span v-if="postwork.reflection.do_job_in_future === 2">I'm Unsure</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span role="heading" aria-level="3">Additional thoughts/reflections (optional):</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              {{ postwork.reflection.reflections }}
            </div>
          </div>
        </form>
        <div v-if="loginType == 'student'" class="pt-10">
          <button class="btn btn-secondary btn-size-medium" @click="downloadReflection">
            View Reflection
          </button>
          <vs-progress indeterminate color="primary" v-if="downloadingReflection"></vs-progress>
        </div>
      </template>
    </div>
    <br />
  </vx-card>
</template>

<script>
import state from '@/store/store';
import store from '@/store/store';
import theApi from '@/mixins/theApi';

export default {
  computed: {
    experience() {
      const loginType = this.loginType;
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return state.getters['authTeacher/experience'];
      }
    },
    postwork() {
      if (
        typeof this.experience.postwork !== 'undefined' &&
        this.experience.postwork != null &&
        typeof this.experience.postwork.reflection !== 'undefined' &&
        this.experience.postwork.reflection != null
      )
        return this.experience.postwork;
      else return null;
    },
  },
  data() {
    return {
      skills: [
        'Communication',
        'Teamwork',
        'Problem Solving',
        'Collaboration',
        'Flexibility',
        'Digital Literacy',
        'Presentation Skills',
        'Critical Thinking',
        'Creativity',
        'Financial Literacy',
        'Initiative and Enterprise',
        'Planning and Organising',
        'Self Management',
        'Learning and Technology',
      ],
      loginType: localStorage.getItem('login_type'),
      downloadingReflection: false,
    };
  },
  methods: {
    downloadReflection() {
      this.downloadingReflection = true;
      const formDataTL = new FormData();
      formDataTL.append('student_vje_id', this.$route.params.id);
      theApi.methods.makeCall(false, 'reflection/download', 'post', formDataTL).then(
        (data) => {
          if (data.status == 'OK') {
            store.dispatch('popup/showIframePopup', data.url);
            this.downloadingReflection = false;
          }
        },
        () => {
          this.downloadingReflection = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.skillWrapper {
  position: relative;
  padding-left: 25px !important;
}
.hasSkill {
  width: 15px;
  height: 15px;
  color: #528029; /* 4.7:1 on white; was #80c342 at 2.14:1 */
  margin-right: 10px;
  position: absolute !important;
  left: 0;
  top: 4px;
}
</style>
